import { ArrowForwardIcon } from "@chakra-ui/icons";
import React, { useEffect, useState } from "react";
import FirebaseProvider from "../api/firebaseProvider";
import ScratchAPIProvider from "../api/scratchProvider";
import LoadingFullscreen from "../components/LoadingFullscreen";
import Navbar from "../components/Navbar.jsx";
import ScratchathonDatePopover from "../components/ScratchathonDatePopover";
import ScratchathonDetails from "../components/ScratchathonDetails";
import ScratchathonProjectList from "../components/ScratchathonProjectList";
import ScratchathonThemePopover from "../components/ScratchathonThemePopover";
import SortProjects from "../components/SortProjects";
import SubmitProjectPopover from "../components/SubmitProjectPopover";
import { routes } from "../constants/routes";

const ScratchathonPage = () => {
  const [scratchathon, setScratchathon] = useState(null);
  const [projectSort, setProjectSort] = useState("recent");

  useEffect(async () => {
    const scratchathon = await FirebaseProvider.getCurrentScratchathon();
    setScratchathon(scratchathon);
  }, []);

  if (scratchathon === null) {
    return <LoadingFullscreen />;
  }

  return (
    <div className="">
      <div className="scratchathon-bg flex flex-col">
        <Navbar darkBg />
        <div className="container flex flex-col">
          <div className="mt-4">
            <a
              href={routes.learnscratch}
              className="block md:flex p-4 rounded-md w-full cursor-pointer bg-blue-100 hover:bg-blue-50 items-center group transition-colors duration-200"
            >
              <p className="text-blue-500 flex-1">
                <span className="font-bold">New to Scratch?</span> We've got you
                covered.
              </p>
              <p className="font-semibold text-blue-500 justify-end flex items-center space-x-1">
                <span>Learn more</span>
                <ArrowForwardIcon w={5} h={5} />
              </p>
            </a>
          </div>
          <div className="flex-1 py-20 md:py-40 flex flex-col">
            <div className="text-center mx-auto">
              <p className="inline-flex rounded-full items-center space-x-3 py-1 px-6 bg-white">
                <div className="w-1 h-1 p-1 rounded-full bg-red-700 animate-pulse"></div>
                <span className="mx-auto text-red-700 font-bold text-sm uppercase tracking-wider">
                  Live
                </span>
              </p>
              <p className="text-5xl font-semibold my-4 text-white">
                {scratchathon.title}
              </p>
            </div>
          </div>
          <div className="pb-6 md:pb-0 transform space-y-2 md:space-y-0 md:space-x-4 md:translate-y-1/3 mx-auto">
            <ScratchathonThemePopover theme={scratchathon.theme} />
            <SubmitProjectPopover lgBtn scratchathonID={scratchathon.id} />
            <ScratchathonDatePopover dates={scratchathon.dates} />
          </div>
        </div>
      </div>

      <div className="bg-gray-50 py-16">
        <div className="container">
          <ScratchathonDetails />
        </div>
      </div>

      <div className="container py-10 md:py-16">
        <div className="space-y-8">
          <div className="space-y-4">
            <p className="text-2xl text-gray-800 font-medium">
              Browse Submitted Projects
            </p>
            <div className="flex space-x-3">
              <SubmitProjectPopover scratchathonID={scratchathon.id} />
              <SortProjects
                projectSort={projectSort}
                setProjectSort={setProjectSort}
              />
            </div>
          </div>
          <ScratchathonProjectList
            projectSort={projectSort}
            scratchathonID={scratchathon.id}
          />
        </div>
      </div>
    </div>
  );
};

export default ScratchathonPage;
